export const columns = [
  {
    id: "perId",
    label: "Código",
    minWidth: 25,
    tipo: "string",
    orden: 1,
    propiedad: "perId",
    align: "center",
    ocultar: true,
  },

  {
    id: "perDocNumero",
    label: "Cedula",
    minWidth: 25,
    tipo: "string",
    orden: 1,
    propiedad: "perDocNumero",
    align: "center",
    ocultar: true,
  },

  {
    id: "perApellidos",
    label: "Nombres",
    minWidth: 125,
    tipo: "string",
    orden: 1,
    propiedad: "perApellidos",
    align: "center",
    ocultar: true,
  },

  {
    id: "perFecReg",
    label: "Fec. Reg",
    minWidth: 100,
    tipo: "fecha",
    orden: 1,
    propiedad: "perFecReg",
    align: "center",
    ocultar: false,
  },
];
export const objectDefault = {
  perDocTipo: "", // equivalente: perDocTipo
  perDocNumero: "", // equivalente: perDocNumero
  perNombre: "", // equivalente: perNombre
  perApellidos: "",
  perEstadoCivil: "SOLTERO(a)",
  perTelefono: [], // equivalente: perTelefono
  perCelular: "", // equivalente: perCelular
  perDireccion: "", // equivalente: perDireccion
  perFecNacimiento: "", // equivalente: perFecNacimiento
  perPerfil: [], // equivalente: perPerfil
  perEmail: [], // equivalente: perEmail
  perEmpresa: [], // equivalente: perEmpresa
  perCiudad: "",
  perEstado: "ACTIVO", // equivalente: perEstado
  horarios: [], // equivalente: horarios
  perPais: "ECUADOR", // equivalente: perPais
  perProvincia: "SANTO DOMINGO DE LOS TSÁCHILAS", // equivalente: perProvincia
  perCanton: "SANTO DOMINGO", // equivalente: perCanton
  perObsevacion: "", // equivalente: perObsevacion (con error tipográfico en objeto2)
  perUser: "", // equivalente: perUser
  perFecReg: "", // equivalente: perFecReg
  perFoto: "", // equivalente: perFoto
  perUbicacion: {
    longitud: 0, // equivalente: perUbicacion.longitud
    latitud: 0, // equivalente: perUbicacion.latitud
  },
  perGenero: "", // equivalente: perGenero

  // Propiedades agregadas de objeto2
  perNombreComercial: "",
  perTipoProveedor: "",
  perTiempoCredito: "",
  perObligado: "",
  perCredito: "",
  perOtros: [],
  perNickname: "",
  perDocumento: "",
  perRecomendacion: "",
  perEspecialidad: "",
  perTitulo: "",
  perSenescyt: "",
  perPersonal: "",
  perId: 0,
  perCodigo: "",
  perUsuario: "",
  perFecUpd: "",
};
// const objeto2 = {
//   perNombreComercial: "",
//   perEmpresa: ["ZARACAY"],
//   perPais: "ECUADOR",
//   perProvincia: "SANTO DOMINGO DE LOS TSÁCHILAS",
//   perCanton: "SANTO DOMINGO",
//   perTipoProveedor: "BIENES",
//   perTiempoCredito: "0",
//   perDocTipo: "CEDULA",
//   perDocNumero: "1003995295",
//   perPerfil: ["CLIENTE", "USUARIO"],
//   perNombre: "RIERA ALVAREZ GEANINNA SILVANA",
//   perDireccion: "Coop. Libertador y La Carchense",
//   perObligado: "NO",
//   perCredito: "NO",
//   perTelefono: "0",
//   perCelular: ["‪+593963816825‬"],
//   perEstado: "ACTIVO",
//   perObsevacion: "",
//   perEmail: ["rieraalvarezsilvana@gmail.com"],
//   perOtros: ["JP810R"],
//   perNickname: null,
//   perUser: "1003995295",
//   perFoto: "",
//   perUbicacion: {
//     longitud: "",
//     latitud: "",
//   },
//   perDocumento: "",
//   perGenero: "M",
//   perRecomendacion: "OTROS",
//   perFecNacimiento: "1989-04-07",
//   perEspecialidad: "EMPLEADO PRIVADO",
//   perTitulo: "",
//   perSenescyt: "",
//   perPersonal: "INTERNO",
//   perId: 7202,
//   perCodigo: "1003995295",
//   perUsuario: "1003995295",
//   perFecReg: "2025-03-26T13:29:40.000Z",
//   perFecUpd: "2025-04-08T23:28:18.000Z",
//   horarios: [
//     {
//       fechas_milisegundos: [
//         {
//           desde: 1739336400000,
//         },
//       ],
//       fechas_iso: [
//         {
//           desde: "2025-04-09 10:22:28",
//           hasta: "2025-04-09 19:22:30",
//           id: 1,
//         },
//       ],
//       id: "7660a0c5-5e6e-4078-bbe7-1b5228970cf3",
//     },
//   ],
// };
